/* Primary Colors
----------------------------------------------- */
export const primaryColors = {
    zuerichBlue: "#0070bc",
    white: "#FFFFFF",
    darkGrey: "#4C4C4C"
};
/* Secondary Colors
----------------------------------------------- */
export const secondaryColors = {
    red: "#d0021b",
    yellow: "#E6BC17",
    green: "#73BF26"
};
/* Color Palettes
----------------------------------------------- */
export const zuerichBlueColors = {
    "50": "#e5f0f8",
    "100": "#cee2f2",
    "200": "#b6d5eb",
    "300": "#9dc7e5",
    "400": "#83b9de",
    "500": "#70aad7",
    "600": "#5e9bd1",
    "700": "#4b8dca",
    "800": "#317ec3",
    "900": primaryColors.zuerichBlue
};
export const redColors = {
    "50": "#fcf2f3",
    "100": "#fddcd9",
    "200": "#fcc7bf",
    "300": "#fab1a5",
    "400": "#f69a8d",
    "500": "#f18475",
    "600": "#ea6e5e",
    "700": "#e35547",
    "800": "#da3831",
    "900": secondaryColors.red
};
export const greyColors = {
    "50": "#f5f5f5",
    "100": "#eeeeee",
    "200": "#cccccc",
    "300": "#b9b9b9",
    "400": "#a6a6a6",
    "500": "#939393",
    "600": "#808080",
    "700": "#6e6e6e",
    "800": "#5d5d5d",
    "900": primaryColors.darkGrey
};



// WEBPACK FOOTER //
// ./src/theme/colors.ts